import axios from 'axios';
import { Category, SERVER_URL } from './EnvironmentConfig';

export const getUserSchool = async (userId) => {
  try {
    const url = `${SERVER_URL}/user/get-user-school`;
    const response = await axios.post(url, {
      id: userId,
    });
    return response.data;
  } catch (err) {
    console.log('Error fetching user school from Database', err);
  }
};

export const getAllSubject = async () => {
  try {
    const url = `${SERVER_URL}/context/get-all-subject`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log('Error fetching subjects from Database', err);
  }
};

export const getAllCompanyInfo = async (id) => {
  try {
    const url = `${SERVER_URL}/business/get-all`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log('Error fetching subjects from Database', err);
  }
};

export const getAllEatInfo = async () => {
  try {
    const url = `${SERVER_URL}/business/businesses/eat`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log('Error fetching subjects from Database', err);
  }
};

export const getSingleCompImp = async () => {
  try {
    const url = `${SERVER_URL}/business/get-all`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log('Error fetching subjects from Database', err);
  }
};

export const getAllSemesterYear = async () => {
  try {
    const url = `${SERVER_URL}/context/get-all-semester-year`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log('Error fetching Year from Database', err);
  }
};

export const getAllSemester = async () => {
  try {
    const url = `${SERVER_URL}/context/get-all-semester`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log('Error fetching Semester from Database', err);
  }
};

export const getAllLevel = async () => {
  try {
    const url = `${SERVER_URL}/context/get-all-level`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getAllAppMethod = async () => {
  try {
    const url = `${SERVER_URL}/context/get-all-app-method`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getAllResource = async () => {
  try {
    const url = `${SERVER_URL}/context/get-all-resource`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getAllCollisionCompanies = async (catId) => {
  try {
    const url = `${SERVER_URL}/general/get-all-collision-brands`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log('Error fetching Collision Companies', err);
  }
};

export const getLatestRating = async (userId, catId) => {
  try {
    const url = `${SERVER_URL}/ratings/get-user-latest-rating-for-category`;
    const response = await axios.post(url, {
      userId,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error fetching User latest Rating', err);
  }
};

export const getAllCategoryQuestions = async (catId, page, limitValue) => {
  try {
    const url = `${SERVER_URL}/context/get-all-rating-questions/?page=${page}&limit=${limitValue}`;
    const response = await axios.post(url, {
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching all category questions', err);
  }
};

export const getAllCategory = async () => {
  try {
    const url = `${SERVER_URL}/context/get-all-category`;
    const response = await axios.post(url);
    return response;
  } catch (err) {
    console.log('Error Fetching all category questions', err);
  }
};

export const getAllCompany = async () => {
  try {
    const url = `${SERVER_URL}/business/get-all`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching all companies:', err);
    return []; // Return empty array instead of undefined
  }
};

export const getAllQuestions = async (catId) => {
  try {
    const url = `${SERVER_URL}/business/add-category-questions/${catId}`;
    // const url = `${SERVER_URL}/businessQuestion/question/${catId}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.error('Error fetching all companies:', err);
    return []; // Return empty array instead of undefined
  }
};

export const getRatingsByUser = async (userId, contentId, catId) => {
  try {
    const url = `${SERVER_URL}/entertainment/get-ratings-by-user`;
    const response = await axios.post(url, {
      userId,
      contentId,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Rating By User', err);
  }
};

export const getRatingsBySchool = async (school, catId) => {
  try {
    const url = `${SERVER_URL}/education/get-ratings-by-school`;
    const response = await axios.post(url, {
      school,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Rating By User', err);
  }
};

export const getRatingsByURL = async (resourceUrl, catId) => {
  try {
    const url = `${SERVER_URL}/education/get-ratings-by-url`;
    const response = await axios.post(url, {
      resourceUrl,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Rating By User', err);
  }
};

export const getRatingsByISBN = async (ISBN, catId) => {
  try {
    const url = `${SERVER_URL}/education/get-ratings-by-isbn`;
    const response = await axios.post(url, {
      resourceISBN: ISBN,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Rating By User', err);
  }
};

export const getRatingsBySchoolAndYear = async (school, year, catId) => {
  try {
    const url = `${SERVER_URL}/education/get-ratings-by-school-year`;
    const response = await axios.post(url, {
      school,
      year,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Rating By User', err);
  }
};

export const getRatingsBySchoolAndSubject = async (school, subject, catId) => {
  try {
    const url = `${SERVER_URL}/education/get-ratings-by-school-subject`;
    const response = await axios.post(url, {
      school,
      subject,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Rating By User', err);
  }
};

export const getRatingsById = async (contentId, catId) => {
  try {
    const url = `${SERVER_URL}/entertainment/get-ratings-by-id`;
    const response = await axios.post(url, {
      contentId,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Rating By Id', err);
  }
};

export const getLatestRatingByUser = async (userId, contentId, catId) => {
  try {
    const url = `${SERVER_URL}/entertainment/get-latest-rating-for-user`;
    const response = await axios.post(url, {
      userId,
      contentId,
      catId,
    });
    return response.data;
  } catch (err) {
    console.log('Error Fetching Latest Rating By User', err);
  }
};

export const getMyProductsData = async (userId) => {
  try {
    const url = `${SERVER_URL}/my-products/getMyProductsByUserId`;
    const response = await axios.post(url, {
      userId,
    });
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

// export async function getCategoryTitle(cat) {
//   try {
//     const response = await fetch(`${SERVER_URL}/context/get-all-category`);
//     if (!response.ok) {
//       throw new Error('Failed to fetch categories');
//     }

//     const result = await response.json();
//     if (!result || !result.data || !Array.isArray(result.data)) {
//       throw new Error('Invalid data format');
//     }

//     return result.data;
//   } catch (error) {
//     console.error('Error fetching category:', error);
//     return null;
//   }
// }

export async function getCategoryTitle(catName) {
  try {
    const response = await fetch(`${SERVER_URL}/context/get-all-category`);
    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }

    const result = await response.json();
    if (!result || !result.data || !Array.isArray(result.data)) {
      throw new Error('Invalid data format');
    }

    // Extract all titles
    const categories = result.data;
    const category = categories.find(
      (cat) => cat.title.toLowerCase() === catName.toLowerCase(),
    );

    // return category ? { ID: category._id, title: category.title } : null;
    return category ? category._id : null;
  } catch (error) {
    console.error('Error fetching category:', error);
    return null;
  }
}

// export const getCategoryInformation = (cat) => {
//   const output = {
//     ID: '',
//     title: '',
//   };
//   console.log(cat ,output)
//   switch (cat) {
//     case 'movie':
//       output.ID = Category.MOVIE.ID;
//       output.title = 'Movie';
//       return output;
//     case 'tv':
//       output.ID = Category.TELEVISION.ID;
//       output.title = 'Show';
//       return output;
//     case 'game':
//       output.ID = Category.VIDEO_GAMES.ID;
//       output.title = 'Game';
//       return output;
//     case 'school':
//       output.ID = Category.SCHOOL;
//       output.title = 'School';
//       return output;
//     case 'class':
//       output.ID = Category.CLASS;
//       output.title = 'Class';
//       return output;
//     case 'textbook':
//       output.ID = Category.TEXTBOOK;
//       output.title = 'Textbook';
//       return output;
//     case 'onlinelearning':
//       output.ID = Category.ONLINE_LEARNING;
//       output.title = 'Online Learning';
//       return output;
//     case 'onlineresource':
//       output.ID = Category.ONLINE_RESOURCE;
//       output.title = 'Online Resource';
//       return output;
//     case 'article':
//       output.ID = Category.ARTICLE;
//       output.title = 'Article';
//       return output;
//     case 'misdis':
//       output.ID = Category.MISDISINFO;
//       output.title = 'Misinformation/Disinformation';
//       return output;
//     case 'jobprospect':
//       output.ID = Category.JOB_PROSPECT;
//       output.title = 'Job Prospect';
//       return output;
//     case 'applicationprocess':
//       output.ID = Category.APPLICATION_PROCESS;
//       output.title = 'Application Process';
//       return output;
//     case 'mentalhealth':
//       output.ID = Category.MENTAL_HEALTH;
//       output.title = 'Mental Health';
//       return output;
//     case 'collision':
//       output.ID = Category.COLLISION;
//       output.title = 'Collision';
//       return output;
//     case 'cinemas':
//       output.ID = Category.CINEMAS;
//       output.title = 'Cinemas';
//       return output;
//     case 'restaurants':
//       output.ID = Category.RESTAURANTS;
//       output.title = 'Restaurants';
//       return output;

//     case 'delivery':
//       output.ID = Category.DELIVERY;
//       output.title = 'Delivery';
//       return output;
//     case 'cpg':
//       output.ID = Category.CPG;
//       output.title = 'CPG';
//       return output;
//     default:
//       window.location.replace('/*');
//   }
// };
// export const getCategoryInformation = (cat) => {
//   if (!cat) return null;

//   // Normalize Category keys to lowercase for lookup
//   const categoryEntries = Object.entries(Category);
//   const matchedEntry = categoryEntries.find(([key]) => key.toLowerCase() === cat.toLowerCase());
// console.log(categoryEntries, matchedEntry)
//   if (!matchedEntry) {
//     window.location.replace('/*');
//     return null;
//   }

//   const [rawKey, rawValue] = matchedEntry;

//   const ID = typeof rawValue === 'object' ? rawValue.ID : rawValue;

//   // Convert rawKey to Title Case for display
//   const title = rawKey
//     .toLowerCase()
//     .replace(/_/g, ' ')
//     .replace(/\b\w/g, char => char.toUpperCase());

//   return { ID, title };
// };
export const getCategoryInformation = (cat) => {
  if (!cat) return null;

  // Custom remapping for special cases
  const aliasMap = {
    tv: 'TELEVISION',
    game: 'VIDEO_GAMES',
  };

  const lookupKey =
    aliasMap[cat.toLowerCase()] ||
    Object.keys(Category).find(
      (key) => key.toLowerCase() === cat.toLowerCase(),
    );

  if (!lookupKey || !Category[lookupKey]) {
    window.location.replace('/*');
    return null;
  }

  const rawValue = Category[lookupKey];

  const ID = typeof rawValue === 'object' ? rawValue.ID : rawValue;

  // Convert key to readable title
  const title = lookupKey
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  return { ID, title };
};

export async function handleMyProductAddition(productData) {
  try {
    const addProductUrl = `${SERVER_URL}/my-products`;

    await axios.post(addProductUrl, JSON.stringify(productData), {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (err) {
    console.log(err);
  }
}

export async function handleEntertainmentAddition(ratings) {
  try {
    // Get the number of points to be awarded to the user
    const getNextPointsUrl = `${SERVER_URL}/entertainment/get-next-points-by-user`;
    console.log(ratings);
    const response = await axios.post(getNextPointsUrl, {
      userId: ratings.userId,
    });
    const points = response.data.points;
    console.log('Points: ', points);

    const postEntertainmentRatingUrl = `${SERVER_URL}/entertainment`;

    await axios.post(postEntertainmentRatingUrl, JSON.stringify(ratings), {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Award the user the points
    const awardPointsUrl = `${SERVER_URL}/user/update-points-balance`;
    await axios.post(awardPointsUrl, {
      userId: ratings.userId,
      points,
      activity: 'Rating',
      contentId: ratings.contentId,
      contentName: ratings.contentName,
    });
  } catch (err) {
    console.log(err);
  }
}

export async function handleEducationAddition(ratings) {
  try {
    const postEducationRatingUrl = `${SERVER_URL}/education`;

    await axios.post(postEducationRatingUrl, JSON.stringify(ratings), {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (err) {
    console.log(err);
  }
}

export async function handleCollisionAddition(ratings) {
  try {
    const postEducationRatingUrl = `${SERVER_URL}/general/submit-collision-rating`;

    await axios.post(postEducationRatingUrl, JSON.stringify(ratings), {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (err) {
    console.log('Error adding to collision DB', err);
  }
}
